<template lang="pug">
.message-system
  .message-system-content(v-html="systemMessage", :class="{'pad-right' : inWebchat}")
  aiq-timeago(v-if="!inWebchat" :since="messageDate" :maxTime="maxTime")
</template>

<script>
import get from 'lodash/get';
import BaseMessage from './BaseMessage/BaseMessage.vue';

const SYSTEM_ACTION = {
  AGENT_ATTACHED: 'conversations.agents.attach',
  AGENT_DETACHED: 'conversations.agents.detach',
};

export default {
  extends: BaseMessage,
  name: 'systemMessage',
  props: {
    inWebchat: Boolean,
  },
  computed: {
    isDisplayNameVisible() {
      return get(this.accountFieldsVisibilityConfig, 'display_name.show', true);
    },
    systemMessage() {
      const key = get(this.message, 'payload.system.action');
      let langKey = '';
      if (!key) {
        return this.content;
      }

      const interpolationData = {};
      if (key === SYSTEM_ACTION.AGENT_ATTACHED || key === SYSTEM_ACTION.AGENT_DETACHED) {
        const agents = get(this.message, 'payload.system.data.agents', []);
        const agentNames = this.isDisplayNameVisible ? agents.map(a => get(a, 'display_name') || a.name) : agents.map(a => a.name);
        interpolationData.agents = agentNames.join(', ');
        const joinedKey = agentNames.length > 1 ? 'agents_joined' : 'agent_joined';
        langKey = key === SYSTEM_ACTION.AGENT_ATTACHED ? joinedKey : 'agent_left';
      } else {
        // langKey is generated based on system action with snake casing
        langKey = key.replaceAll('.', '_');
      }

      return this.getString(`messages.system.${langKey}`, { defaultValue: this.content, ...interpolationData });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../aiq-theme/aiq-variables';

.message-system {
  .message-system-content + div {
    margin-left: 10px;
  }
}
.pad-right{
  padding-right: 26px;
  color: $aiq-webchat-ligher-text;
}
</style>
